export default __webpack_public_path__ + "static/media/amortizationCalculator.845e6e07.svg";